import React, { useState,useEffect } from 'react';
import PayrollForm from './PayrollForm';
import Pagination from '../../../utils/pagination/Pagination';
import { Trash2, SquarePen, Eye, Plus } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { pageData } from '../../../utils/paginationConfig';

import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  ModalCloseButton
} from '@chakra-ui/react'
import { getPayroll } from '../../../redux/reduxApi/payrollReduxApi';
import { Link } from 'react-router-dom';
import './Payroll.css';


function Payroll() {
  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  

  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [complianceROWID, setComplianceROWID] = useState("");
  const [dataToEdit, setDataToEdit] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [totalCount, setTotalCount] = useState(0);


  //Fetch Compliace data from Redux
  const getPayrollData = useSelector((state) => state?.payroll?.payroll);
  console.log("getPayrollData ===>", getPayroll);

  const [PayrollData, setPayrollData] = useState([]);
  console.log(PayrollData);


  useEffect(() => {
    setPayrollData(getPayrollData);
  }, [getPayrollData]);

  // Get Payroll -->
  useEffect(() => {
    const page = 1;
    setLoading(true);
    dispatch(getPayroll(page))  // Dispatch API to fetch Compliance data
      .then((response) => {
        // This will automatically update the Redux store via your reducer
      })
      .catch((error) => {
        console.error("Error fetching Payroll data:", error);
      })
      .finally(() => {
        setLoading(false);
        // setTimeout(() => {
        // }, [300])
      });
  }, [dispatch]);
  
  useEffect(() => {
    console.log({ PayrollData })
    if ( PayrollData &&  PayrollData.length > 0) {
    setData(PayrollData);
    }
    }, [PayrollData])

  useEffect(() => {
    if (currentPage % pageData.apiHit === 0) {
      const page = (currentPage / pageData.apiHit) + 1;
      dispatch(getPayroll(page))
    }
  }, [totalPages]);


  // total Compliance count
  // const fetchTotalCount = async () => {
  //   try {
  //     const response = await countCompliance();
  //     console.log("API Response:", response.data);
  //     const count = parseInt(response.data.response.count, 10);
  //     setTotalCount(count);
  //   } catch (error) {
  //     console.error("Error fetching total Compliance count:", error);
  //   }
  // };
  //   useEffect(() => {
  //     fetchTotalCount();
  //   }, []);

  // console data to be displayed



      // All Select

      const handleSelectAllRows = () => {
        const allSelected = selectedRows.length === data.length;
        let newSelectedRows = [];
        if (!allSelected) {
          newSelectedRows = data.map(item => item?.ROWID);
        }
        setSelectedRows(newSelectedRows);
        console.log(newSelectedRows)
      };
  


  const openDrawer = () => {
    setIsDrawerOpen(true)
  }
  const closeDrawer = () => {
    setIsDrawerOpen(false)
  }
  // for Trash modal
  const openTrash = () => {
    setIsOpen(true)
  }
  const closeTrash = () => {
    setIsOpen(false)
  }
  // const heading = [
  //   { th: <Checkbox key="checkbox" /> },
  //   { th: 'Actions' },
  //   { th: 'Employee ID' },
  //   { th: 'First Name' },
  //   { th: 'Last Name' },
  //   { th: 'Email' },
  //   { th: 'Date Of Joining' },
  //   { th: 'Designation' },
  //   { th: 'Department' },
  //   { th: 'Gender' },
  //   { th: 'Work Location' },

  // ];

  // const [formData, setFormData] = useState(
  //   {
  //     employeeid: '',
  //     firstname: '',
  //     lastname: '',
  //     employeeid: '',
  //     dateofjoining: '',
  //     email: '',
  //     gender: '',
  //     worklocation: '',
  //     designation: '',
  //     department: '',
  //   }
  // )

  // const payrollData = [
  //   {
  //     firstname: 'John',
  //     lastname: 'Doe',
  //     employeeid: 'E001',
  //     dateofjoining: '2023-01-15',
  //     email: 'john.doe@example.com',
  //     gender: 'Male',
  //     worklocation: 'New York',
  //     designation: 'Software Engineer',
  //     department: 'Engineering'
  //   },
  //   {
  //     firstname: 'John',
  //     lastname: 'Doe',
  //     employeeid: 'E001',
  //     dateofjoining: '2023-01-15',
  //     email: 'john.doe@example.com',
  //     gender: 'Male',
  //     worklocation: 'New York',
  //     designation: 'Software Engineer',
  //     department: 'Engineering'
  //   },
  //   {
  //     firstname: 'John',
  //     lastname: 'Doe',
  //     employeeid: 'E001',
  //     dateofjoining: '2023-01-15',
  //     email: 'john.doe@example.com',
  //     gender: 'Male',
  //     worklocation: 'New York',
  //     designation: 'Software Engineer',
  //     department: 'Engineering'
  //   },
  //   {
  //     firstname: 'John',
  //     lastname: 'Doe',
  //     employeeid: 'E001',
  //     dateofjoining: '2023-01-15',
  //     email: 'john.doe@example.com',
  //     gender: 'Male',
  //     worklocation: 'New York',
  //     designation: 'Software Engineer',
  //     department: 'Engineering'
  //   },
  //   {
  //     firstname: 'John',
  //     lastname: 'Doe',
  //     employeeid: 'E001',
  //     dateofjoining: '2023-01-15',
  //     email: 'john.doe@example.com',
  //     gender: 'Male',
  //     worklocation: 'New York',
  //     designation: 'Software Engineer',
  //     department: 'Engineering'
  //   },
  //   {
  //     firstname: 'Jane',
  //     lastname: 'Smith',
  //     employeeid: 'E002',
  //     dateofjoining: '2022-08-20',
  //     email: 'jane.smith@example.com',
  //     gender: 'Female',
  //     worklocation: 'San Francisco',
  //     designation: 'Product Manager',
  //     department: 'Product'
  //   },
  //   {
  //     firstname: 'Michael',
  //     lastname: 'Johnson',
  //     employeeid: 'E003',
  //     dateofjoining: '2021-11-05',
  //     email: 'michael.john@example.com',
  //     gender: 'Male',
  //     worklocation: 'Chicago',
  //     designation: 'Data Scientist',
  //     department: 'Data Science'
  //   },
  //   {
  //     firstname: 'Emily',
  //     lastname: 'Davis',
  //     employeeid: 'E004',
  //     dateofjoining: '2023-03-10',
  //     email: 'emily.davis@example.com',
  //     gender: 'Female',
  //     worklocation: 'Los Angeles',
  //     designation: 'Marketing Spec.',
  //     department: 'Marketing'
  //   },
  //   {
  //     firstname: 'William',
  //     lastname: 'Brown',
  //     employeeid: 'E005',
  //     dateofjoining: '2022-05-18',
  //     email: 'william.b@example.com',
  //     gender: 'Male',
  //     worklocation: 'Seattle',
  //     designation: 'Sales Manager',
  //     department: 'Sales'
  //   }
  // ];

  return (
    <>
    {loading && (
     <div className="spinner-overlay">
       <Spinner size="xl" color="pink.500" />
     </div>
      )}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          </ModalBody>
          <ModalFooter>
            <Button className='create-button' mr={3} onClick={closeTrash}>
              Delete
            </Button>
            <Button className='cancel-button' onClick={closeTrash}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div >
        <div className='d-flex justify-content-end' onClick={openDrawer}>
          <button className="new-button mx-2" ><Plus size="18px" /><span className='ms-1' onClick={openDrawer} >New</span></button>
        </div>
        <div className='custom-scroll ' style={{ minHeight: "75vh" }}>
          <TableContainer className='card card-detail mt-1'>
            <Table variant='simple' size='sm' >
              <Thead>
                <Tr className='tr-border'>
                <Th className='py-1 th-color'>
                  <Checkbox isChecked={selectedRows?.length === data?.length} onChange={handleSelectAllRows} />
                  </Th>
                  <Th className='py-1 th-color'>Actions</Th>
                  <Th className='py-1 th-color'>Employee ID</Th>
                  <Th className='py-1 th-color'>First Name</Th>
                  <Th className='py-1 th-color'>Last Name</Th>
                  <Th className='py-1 th-color'>Email</Th>
                  <Th className='py-1 th-color'>Date Of Joining </Th>
                  <Th className='py-1 th-color'>Designation</Th>
                  <Th className='py-1 th-color'>Department</Th>
                  <Th className='py-1 th-color'>Gender</Th>
                  <Th className='py-1 th-color'>Work Location</Th>
                </Tr>
              </Thead>
              <Tbody>
                {/* {payrollData && payrollData.slice((currentPage - 1) * 30, currentPage * 30).map((item, index) => (
                  <tr className='tr-border' key={index}>
                    <td className='td-class'><Checkbox /></td>
                    <td className='td-class'>
                      <div className="d-flex gap-1">
                        <Link to="/payroll-detail-view">
                          <i style={{ cursor: 'pointer' }}><Eye color="#ff176b" size="16px" strokeWidth="1" /></i>
                        </Link>
                        <i onClick={openDrawer} style={{ cursor: 'pointer' }}><SquarePen color="#ff176b" size="16px" strokeWidth="1" /></i>
                        <i style={{ cursor: 'pointer' }}><Trash2 color="#ff176b" size="16px" strokeWidth="1" onClick={openTrash}/></i>
                      </div>
                    </td>
                    <Td className='font-colors'>{item.employeeid}</Td>
                    <Td className='font-colors'>{item.firstname}</Td>
                    <Td className='font-colors'>{item.lastname}</Td>
                    <Td className='font-colors'>{item.email}</Td>
                    <Td className='font-colors'>{item.dateofjoining}</Td>
                    <Td className='font-colors'>{item.designation}</Td>
                    <Td className='font-colors'>{item.department}</Td>
                    <Td className='font-colors'>{item.gender}</Td>
                    <Td className='font-colors'>{item.worklocation}</Td>

                  </tr>
                ))} */}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
        {/* Pagination */}
        <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto" >
          <Pagination totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
        {/* End Pagination */}
        <PayrollForm closeDrawer={closeDrawer} isDrawerOpen={isDrawerOpen} />
      </div>
    </>
  )
}

export default Payroll